module.exports = __webpack_public_path__ + "static/flags/AC-d7d64b6c4e259377f6bada489ee82f5d.gif";